import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import Remainder from '../interfaces/remainder';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Unit } from '../enums/unit';
import { DefaultFormats } from '../enums/default-formats';

export class RemainderService extends HttpClient {
  index(farmId: string, params: ListParams) {
    return this.get<Paginate<Remainder>>(
      `/api/farms/${farmId}/remainders`,
      params
    );
  }

  exportXls(farmId: string, params: ListParams) {
    return this.export(`/api/farms/${farmId}/remainders`, params);
  }

  validate(
    farmId: string,
    date: string | Date,
    productObtainTypeId: string,
    productCategoryId: string,
    productTypeId: string,
    productId: string,
    unit: string,
    amount: string | number,
    warehouseId?: string
  ): Observable<boolean> {
    if (
      !date ||
      !productObtainTypeId ||
      !productCategoryId ||
      !productTypeId ||
      !productId ||
      !amount ||
      !unit
    ) {
      return of(false);
    }

    switch (unit) {
      case Unit.TON:
        unit = Unit.KILOGRAM;
        amount = parseFloat(amount.toString()) * 1000;
        break;
      case Unit.GRAM:
        unit = Unit.KILOGRAM;
        amount = parseFloat(amount.toString()) / 1000;
        break;
      case Unit.MILLILITER:
        unit = Unit.LITER;
        amount = parseFloat(amount.toString()) / 1000;
    }

    if ((date as any).toLocaleDateString) {
      date = (date as any).toLocaleDateString(DefaultFormats.DATE_FILTER);
    }

    return this.index(farmId, {
      to: date,
      product_obtain_type_id: productObtainTypeId,
      product_category_id: productCategoryId,
      product_type_id: productTypeId,
      product_id: productId,
      unit: unit,
      warehouse_id: warehouseId,
    }).pipe(
      map((response) => {
        if (!response.data.length) {
          return true;
        }

        return parseFloat(response.data[0].amount) < amount;
      })
    );
  }
}
